module.exports = __webpack_public_path__ + "static/media/img_4.bed2813e.png";